// extracted by mini-css-extract-plugin
export var component = "SiteBanner-module--component--kfK-9";
export var wrapper = "SiteBanner-module--wrapper--++1xu";